import { render, staticRenderFns } from "./BoxFile.vue?vue&type=template&id=2430fe66&"
import script from "./BoxFile.vue?vue&type=script&lang=js&"
export * from "./BoxFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports